<template>
  <div class="device-param-billtable-bd">
    <div class="table-title">
      <!-- {{ $t('page_content_configBill') }} -->
      {{ $t('dms_device_param_billTable.dqjqsj') }}
      <el-button @click="emitRefreshCompoment" style="float: right" size="mini" :disabled="asyncing">
        <i class="icon icon-shuaxin"></i>
        {{ $t('dms_device_param_billTable.shua_xin_shu_ju') }}
        <span v-if="asyncing">（{{ $t('dms_device_param_billTable.shua_xin_zhong') }}... ）</span>
      </el-button>
    </div>
    <!-- 有数据才显示 -->
    <h2 class="table-title tips-title" v-if="childComponentDesc">
      <div class="tip">
        <i class="icon icon-tishi"></i>
        <span>{{ childComponentDesc }}</span>
      </div>
    </h2>
    <!--
      recoverTable
      tableSingleColumn
    -->
    <el-table :data="tableSingleList" border max-height="100" style="width: 100%">
      <template v-for="(item, index) in tableSingleColumn">
        <el-table-column v-if="item.selected && `${item.widgetType}` !== '8'" :key="index" :prop="item.columnCode" :label="item.columnName"></el-table-column>
        <el-table-column
          v-if="item.selected && `${item.widgetType}` === '8'"
          :key="index"
          :index="index"
          :prop="item.columnCode"
          :label="item.columnName"
          :width="item.width"
          :formatter="item.isFormat ? formatColumn : null"
          :sortable="item.isSort ? 'custom' : null"
          :fixed="item.isLock ? 'right' : null"
        >
          <template slot-scope="{ row, column }">
            {{ row[column.property] !== '-' ? formatDateTimeDate(row[column.property]) : row[column.property] }}
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!--
      paramColumn
      tableSingleColumn
    -->
    <!-- 当前账单 -->
    <div class="table-bd">
      <el-table ref="tb1" v-loading="isLoading" :size="allTableSize" :data="paramList" :loading="isLoading" border height="100%">
        <!-- 配置列 -->
        <template v-for="(item, index) in paramColumn">
          <!-- 字典 -->
          <el-table-column
            v-if="item.selected && item.dicGroup && !item.showUnit"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
            :column-key="item.columnCode"
            :filter-multiple="true"
            :filters="item.filters"
            show-overflow-tooltip
          >
            <template slot-scope="{ row, column }">
              {{ getDicValue(item.dicGroup, row[column.property]) }}
            </template>
          </el-table-column>
          <!-- 单位 -->
          <el-table-column
            v-if="item.selected && item.showUnit"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
          >
            <template slot-scope="{ row, column }">
              <span>{{ row[column.property] }}</span>
              <span style="margin-left: 5px">{{ getDicValue('iot_tsl_data_unit', item.showUnit) }}</span>
            </template>
          </el-table-column>
          <!--
              datetime 5 时间控件
          -->
          <el-table-column
            v-if="item.selected && (`${item.widgetType}` === '5' || `${item.widgetType}` === '8') && !item.showUnit"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
          >
            <template slot-scope="{ row, column }">
              {{ row[column.property] !== '-' ? formatDateTimeDate(row[column.property]) : row[column.property] }}
            </template>
          </el-table-column>
          <!-- 非字典  时间控件 -->
          <el-table-column
            v-if="item.selected && `${item.widgetType}` !== '5' && `${item.widgetType}` !== '8' && !item.dicGroup && !item.showUnit"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
            :column-key="item.columnCode"
            :filter-multiple="true"
            :filters="item.filters"
            show-overflow-tooltip
          ></el-table-column>
        </template>
        <!-- 占位列 -->
        <el-table-column v-if="!tableColumn.length"></el-table-column>
      </el-table>
    </div>
    <div class="table-title" style="margin-top: 10px">
      <!-- {{ $t('dialog_title_original_bill }} -->
      {{ $t('dms_device_param_billTable.zhxfsj') }}
      <el-button style="float: right" size="mini" @click="onChangeBill()" v-if="isEdit">
        <i class="icon icon-bianji"></i>
        {{ $t('dms_device_param_billTable.xiu_gai_pei_zhi') }}
      </el-button>
    </div>
    <el-table :data="recoverHisSingelData" border max-height="100" style="width: 100%">
      <template v-for="(item, index) in recoverHisSingel">
        <el-table-column v-if="item.selected && `${item.widgetType}` !== '8'" :key="index" :prop="item.columnCode" :label="item.columnName"></el-table-column>
        <el-table-column
          v-if="item.selected && `${item.widgetType}` === '8'"
          :key="index"
          :index="index"
          :prop="item.columnCode"
          :label="item.columnName"
          :width="item.width"
          :formatter="item.isFormat ? formatColumn : null"
          :sortable="item.isSort ? 'custom' : null"
          :fixed="item.isLock ? 'right' : null"
        >
          <template slot-scope="{ row, column }">
            {{ row[column.property] !== '-' ? formatDateTimeDate(row[column.property]) : row[column.property] }}
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- 原始数据 -->
    <div class="table-bd">
      <el-table ref="tb1" :data="hisBillList" :loading="isHisLoading" :size="allTableSize" height="100%" resizable border>
        <!-- 配置列 -->
        <template v-for="(item, index) in hisTableColumns">
          <!-- 字典 -->
          <el-table-column
            v-if="item.selected && item.dicGroup && !item.showUnit"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
            :column-key="item.columnCode"
            :filter-multiple="true"
            :filters="item.filters"
            show-overflow-tooltip
          >
            <template slot-scope="{ row, column }">
              {{ getDicValue(item.dicGroup, row[column.property]) }}
            </template>
          </el-table-column>
          <!-- 单位 -->
          <el-table-column
            v-if="item.selected && item.showUnit"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
          >
            <template slot-scope="{ row, column }">
              <span>{{ row[column.property] }}</span>
              <span style="margin-left: 5px">{{ getDicValue('iot_tsl_data_unit', item.showUnit) }}</span>
            </template>
          </el-table-column>
          <!--
              datetime 5 时间控件
          -->
          <el-table-column
            v-if="item.selected && (`${item.widgetType}` === '5' || `${item.widgetType}` === '8') && !item.showUnit"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
          >
            <template slot-scope="{ row, column }">
              {{ formatDateTime(row[column.property]) }}
            </template>
          </el-table-column>

          <!-- 非字典  时间控件 -->
          <el-table-column
            v-if="item.selected && `${item.widgetType}` !== '5' && `${item.widgetType}` !== '8' && !item.dicGroup && !item.showUnit"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
            :column-key="item.columnCode"
            :filter-multiple="true"
            :filters="item.filters"
            show-overflow-tooltip
          ></el-table-column>
        </template>
        <!-- 占位列 -->
        <el-table-column v-if="!tableColumn.length"></el-table-column>
      </el-table>
    </div>

    <device-modifyBill-dialog v-if="dialogVisible" :data="dialogData" :model="dialogModel" @close="dialogVisible = false" @success="updateParamItemList"></device-modifyBill-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import deviceModifyBillDialog from './device_modifyBill_dialog.vue';

export default {
  components: { deviceModifyBillDialog },
  props: {
    bodyNum: [String, Number],
    componentCode: [String, Number],
    componentId: [String, Number],
    childComponentDesc: [String],
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // tableCode: 'device_bill_drawer',
      isLoading: '',
      paramList: [],
      paramColumn: [],

      tableSingleList: [],
      tableSingleColumn: [],
      // 账单期数
      periodNum: '',
      // 账单 字典
      paidDicGroup: '',
      paidDic: {},

      dialogVisible: false,
      dialogData: {},
      dialogModel: {},
      recoverPwdObj: {},

      // 原始账单
      hisTableColumns: [],
      hisBillList: [],
      hisperiodNum: '',
      recoverHisPwdObj: {},
      recoverHisSingel: [],
      recoverHisSingelData: [],

      isHisLoading: false,
      asyncing: false,
    };
  },
  mounted() {
    this.isLoading = true;
    this.getParamList();
    // 获取历史账单
    this.getHisList();
    // 支付状态字典
    this.getDictionary('iot_tsl_paid_state', (data) => {
      this.paidDic = this.$transformDicValue(data['iot_tsl_paid_state']);
    });
  },
  methods: {
    // 刷新
    emitRefreshCompoment() {
      this.asyncing = true;
      this.$emit('refreshCompoment');
      this.updateParamItemList();
    },
    // 更新
    updateParamItemList() {
      setTimeout(() => {
        this.asyncing = false;
        this.getParamList();
        this.getHisList();
      }, 8000);
    },
    // 获取账单参数
    getParamList: function () {
      this.$getJSON(apis.DeviceResumeParamItemList, {
        bodyNum: this.bodyNum,
        componentCode: this.componentCode,
      }).then((res) => {
        this.isLoading = false;
        // 没有子级的
        const firstLevelId = res.data.filter(i => `${i.parentId}` === '0');
        // 内容体
        const contentId = res.data.find(i => `${i.parentId}` !== '0').parentId;
        // 过滤内容体
        const tableSingle = firstLevelId.filter(i => i.tslDataId !== contentId);
        const content = firstLevelId.find(i => i.tslDataId === contentId);
        // 一级的单个表格列
        this.tableSingleColumn = tableSingle.map((i) => {
          const item = {};
          item.columnName = i.dataName;
          item.columnCode = i.dataCode;
          item.columnId = i.tslDataId;
          item.widgetType = i.widgetType;
          item.dicGroup = i.dicGroup;
          item.selected = true;
          return item;
        });
        // 一级的数据  取dataValue值
        const recoverTable = [];
        tableSingle.forEach((i) => {
          const item = {};
          item[i.dataCode] = i.dataValue || '-';
          recoverTable.push(item);
          // return item;
        });
        let recoverTableobj = {};
        recoverTable.forEach((item) => {
          recoverTableobj = { ...recoverTableobj, ...item };
        });
        this.tableSingleList = [recoverTableobj];

        // 内容体表格内容
        this.paramList = (content.dataValue && JSON.parse(content.dataValue)) || [];
        this.paramList.sort((a, b) => {
          if (a.billNum === b.billNum) {
            return a.receivableOrg - b.receivableOrg;
          }
          return a.billNum - b.billNum;
        });
        // this.paramList = [{
        //   billNum: 1,
        //   billEndDate: '2012-10-02',
        //   deferredDuration: '2012-10-02',
        //   unlockPwd: '321322',
        //   paid: '0'
        // }];
        // 不为0 有下级的都是下面的表格列
        const paramColumn = res.data.filter(i => `${i.parentId}` !== '0' && `${i.tcpTopicTslClass}` === '2');
        this.paramColumn = paramColumn.map((i) => {
          const item = {};
          item.columnName = i.dataName;
          item.columnCode = i.dataCode;
          item.columnId = i.tslDataId;
          item.widgetType = i.widgetType;
          item.dicGroup = i.dicGroup;
          item.showUnit = i.showUnit;
          item.selected = true;
          // 账单状态要用字典
          // if (i.dataCode === 'paid') {
          //   this.paidDicGroup = i.dicGroup;
          // }
          return item;
        });

        // // 延迟单位
        // const deferredDuration = res.data.find(i => i.dataCode === 'deferredDuration');
        // const showUnit = deferredDuration && deferredDuration.showUnit;

        // // this.paramList = JSON.parse(content.dataValue);

        // if (this.paramList.length) {
        //   this.paramList.forEach((i) => {
        //     i.showUnit = showUnit;
        //   });
        // }
      });
    },
    // 获取历史账单
    getHisList: function () {
      this.isHisLoading = true;
      this.$getJSON(apis.DeviceResumeParamItemLastArchive, {
        bodyNum: this.bodyNum,
        componentCode: this.componentCode,
      }).then((res) => {
        this.isHisLoading = false;
        // 没有子级的
        const firstLevelId = res.data.filter(i => `${i.parentId}` === '0');
        // 内容体
        const contentId = res.data.find(i => `${i.parentId}` !== '0').parentId;
        // 过滤内容体
        const tableSingle = firstLevelId.filter(i => i.tslDataId !== contentId);
        const content = firstLevelId.find(i => i.tslDataId === contentId);
        // 一级的单个表格列
        this.recoverHisSingel = tableSingle.map((i) => {
          const item = {};
          item.columnName = i.dataName;
          item.columnCode = i.dataCode;
          item.columnId = i.tslDataId;
          item.widgetType = i.widgetType;
          item.dicGroup = i.dicGroup;
          item.showUnit = i.showUnit;
          item.selected = true;
          return item;
        });
        // 一级的数据  取dataValue值
        const recoverTable = [];
        tableSingle.forEach((i) => {
          const item = {};
          item[i.dataCode] = i.dataValue || '-';
          recoverTable.push(item);
          // return item;
        });
        let recoverTableobj = {};
        recoverTable.forEach((item) => {
          recoverTableobj = { ...recoverTableobj, ...item };
        });
        this.recoverHisSingelData = [recoverTableobj];

        this.hisBillList = content.dataValue || [];
        this.hisBillList.sort((a, b) => {
          if (a.billNum === b.billNum) {
            return a.receivableOrg - b.receivableOrg;
          }
          return a.billNum - b.billNum;
        });
        // this.hisBillList = [{
        //   billNum: 1,
        //   billEndDate: '2012-10-02',
        //   deferredDuration: '10',
        //   unlockPwd: '321322',
        //   paid: '0'
        // }];

        // 不为0 有下级的都是下面的表格列
        const paramColumn = res.data.filter(i => `${i.parentId}` !== '0');

        this.hisTableColumns = paramColumn.map((i) => {
          const item = {};
          item.columnName = i.dataName;
          item.columnCode = i.dataCode;
          item.columnId = i.tslDataId;
          item.widgetType = i.widgetType;
          item.dicGroup = i.dicGroup;
          item.showUnit = i.showUnit;
          item.selected = true;
          // 账单状态要用字典
          // if (i.dataCode === 'paid') {
          //   this.paidDicGroup = i.dicGroup;
          // }
          return item;
        });

        // 差单位 h 天 dataCode: "deferredDuration" showUnit: "h"  widgetType: "6"
        // if (this.hisBillList.length) {
        //   this.hisBillList.forEach((i) => {
        //     i.showUnit = showUnit;
        //   });
        // }

        // this.hisTableColumns = paramColumn.map((i) => {
        //   const item = {};
        //   item.columnName = i.dataName;
        //   item.columnCode = i.dataCode;
        //   item.columnId = i.tslDataId;
        //   item.selected = true;
        //   // 账单状态要用字典
        //   if (i.dataCode === 'paid') {
        //     this.paidDicGroup = i.dicGroup;
        //   }
        //   return item;
        // });
      });
    },
    onChangeBill: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('dms_device_param_billTable.xiu_gai_zhang_dan');
      this.dialogModel.type = 'edit';
      this.dialogData.bodyNum = this.bodyNum;
      this.dialogData.componentCode = this.componentCode;
      this.dialogData.componentId = this.componentId;
    },
  },
};
</script>

<style lang="scss">
.device-param-billtable-bd {
  flex: 1;
  display: flex;
  flex-direction: column;
  .title {
    height: 28px;
    margin-bottom: 10px;
    font-weight: bold;
    font-size: 12px;
    color: rgba(73, 80, 87, 1);
    line-height: 28px;
    .period,
    .pwd {
      margin-right: 24px;
      i {
        font-weight: normal;
      }
    }
  }
  .table-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    .table-title {
      height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }

    .table-bd {
      flex: 1;
      height: 100%;
    }
  }
}
</style>
